import { isHttpStatusOK, parseFailed } from '@/apis/utils';
import { getEnv, Auth } from '@/utils';

const { GO_ENDPOINT } = getEnv();

/**
 * 売上げ受取口座を確認するための遷移先URLを取得する。
 *
 * Standard アカウントの場合は Stripe ダッシュボードの固定URLが返る。
 * Express アカウントの場合は使い捨ての Login Link が返るため、
 * 画面表示時ではなくボタンを押した時に呼ぶこと。
 */
async function getShopDashboardLink(userId) {
  try {
    const token = await Auth.getIdToken();
    const response = await fetch(
      `${GO_ENDPOINT}/v1/users/${userId}/shop/dashboard_link`,
      {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (isHttpStatusOK(response.status)) {
      const data = await response.json();
      return data; // { dashboard_url: "https://..." }
    }

    const responseJson = await response.json();
    throw new Error(parseFailed(responseJson.errors[0]));
  } catch (error) {
    return error;
  }
}

export default getShopDashboardLink;
